module.exports = __webpack_public_path__ + "img/forest.7896c60b.svg";